export const AGENT_AUTOMATION = 'agent_insight_automation_form';
export const UNDERWRITING = 'underwriting';
export const AGENT_AUTOMATION_SAVE = 'agent_insight_automation_save';
export const AGENT_AUTOMATION_MODIFY = 'agent_insight_automation_modify';
export const CUSTOMER_CARE = 'ps_entry_form';
export const WORKSITE_TRACKER = 'worksitetracker_form';
export const WORKSITE_TRACKER_MODIFY = 'worksitetracker_modify';
export const EXTRACTS = 'extracts';
export const RECORD_CATALOG = 'RECORD_CATALOG';
export const PSFORM_ADMIN = 'ps_entry_form_admin';
export const WORKSITE_TRACKER_VOID = 'worksitetracker_void';
export const BANK_COMPLIANCE = 'bank_compliance';
export const CLAIM_AUDIT_LOGS = 'claim_audit_logs';
export const CLAIM_AUDIT_LOGS_MANAGER = 'claim_audit_logs_manager';
export const PRODUCTION_TASK = 'production_tasks';
export const PRODUCTION_TASK_CREATE = 'production_tasks_create';
export const PRODUCTION_TASK_MODIFY = 'production_tasks_modify';
export const PRODUCTION_TASK_SUPERVISOR = 'production_tasks_supervisor';
export const PRODUCTION_TASK_EXAMINER = 'production_tasks_examiner';
export const SALESBOARD = 'salesboard';
export const FHDHIERARCHY = 'fhdhierarchy';
export const FHDINPUTFORM = 'fhdinputform';
export const FHDHIERARCHY_ADMIN = 'fhdhierarchy_admin';
export const FHD_ORGANIZATION_SUMMARY = 'fhd_organization_summary';
export const AIL_AGENT_FORM = 'ail_agent_form';

export const LEGAL_COMPLAINTS = 'legal_complaints';
export const LEGAL_COMPLAINTS_ADMIN = 'legal_complaints_admin';
export const LEGAL_EXPENSE = 'legal_expense';
export const LEGAL_EXPENSE_CREATE_CASE = 'legal_expense_create_case';
export const LEGAL_EXPENSE_MODIFY_CASE = 'legal_expense_modify_case';
export const LEGAL_EXPENSE_CREATE_EXPENSE = 'legal_expense_create_expense';
export const LEGAL_EXPENSE_MODIFY_EXPENSE = 'legal_expense_modify_expense';
export const OUTAGE_TRACKER = 'outage_tracker';
export const INVESTMENT = 'investment';
export const INVESTMENT_ADMIN = 'investment_admin';
export const INVESTMENT_CREDIT_ADMIN = 'investment_credit_admin';
export const INVESTMENT_CREDIT_USER = 'investment_credit_user';
export const INVESTMENT_ACCOUNTING_ADMIN = 'investment_accounting_admin';
export const INVESTMENT_ACCOUNTING_USER = 'investment_accounting_user';
export const INVESTMENT_ALTS_ADMIN = 'investment_alts_admin';
export const INVESTMENT_ALTS_USER = 'investment_alts_user';
export const DATA_CATALOGUE = 'data_catalogue';

// Chatbots
export const CHATBOT_CUSTOMESERVICE = 'chatbot_customerservice';
export const CHATBOT_DOCUMENT = 'chatbot_document';
export const CHATBOT_LND_AGENT = 'chatbot_lndagent';
export const CHATBOT_ENTERPRISE_ASSISTANT = 'chatbot_enterprise_assistant';
export const CHATBOT_DATA_ANALYST = 'chatbot_data_analyst';
export const CHATBOT_DEVELOPER = 'chatbot_developer';
export const CHATBOT_ASSISTANT = 'chatbot_assistant';
export const VOICE = 'ranger_voice';
export const VOICE_ADMIN = 'ranger_voice_configure';
export const SALES_COACH = 'chatbot_voice';
export const SALES_COACH_ADMIN = 'chatbot_voice_configure';
export const SALES_COACH_DEV = 'chatbot_voice_dev';
export const CHATS = 'chatbot';
export const CHATBOT_AAI = 'chatbot_aai';
export const CHATBOT_ACTUARIAL = 'chatbot_actuarial';

export const QnA = 'quicksightQnA';
export const ADMIN = 'admin';
export const PRODUCTION_TRACKER = 'production_tracker';
export const LND_PVFC_RECAP = 'lnd_pvfc_recap';
export const CUSTOMER_CARE_USER = 'customer_care_user';
export const CUSTOMER_CARE_SUPERVISOR = 'customer_care_supervisor';
export const CUSTOMER_CARE_ADMIN = 'customer_care_admin';
export const FHD_CAREER_TRACKER = 'fhd_career_tracker';
export const PREMIUM_ACCOUNTING = 'premium_accounting';
export const PREMIUM_ACCOUNTING_USER = 'premium_accounting_user';
export const PREMIUM_ACCOUNTING_SUPERVISOR = 'premium_accounting_supervisor';
export const PREMIUM_ACCOUNTING_ADMIN = 'premium_accounting_admin';
export const PS_ENTRY_FORM_MANUAL = 'ps_entry_form_manual';
export const PS_ENTRY_FORM_AUTO = 'ps_entry_form_auto';
export const GROWTH_ADJUSTMENTS = 'growth_adjustments';
export const PROJECTIONS_PROMOTIONS = 'projections_promotions';
export const CONSERVATION_TRACKER = 'conservation_tracker';
export const FHD_TRAINMORE = 'fhd_trainmore';
export const FHD_LEADERBOARD = 'fhd_leaderboard';
export const ARIA = 'ipa_aria';
export const ARIA_ADMIN = 'ipa_aria_admin';
export const POWER_RANGER = 'power_ranger';
export const CHATBOT_AGENT_REINSTATEMENT_AIL = 'chatbot_agent_reinstatement_ail';
export const CHATBOT_AGENT_REINSTATEMENT_LND = 'chatbot_agent_reinstatement_lnd';
export const DARE = 'dare';
export const DARE_ADMIN = 'dare_admin';
